// Replaced NextParsedUrlQuery with generic object type for React Router compatibility
type ParsedUrlQuery = Record<string, string | string[]>;
import { isValid, isDate, parse } from 'date-fns';
import { DATE_FORMAT_BACKEND_STRING } from './constants';
import { formatStarjackDateToBackendString } from './time';

// TODO: Move to guards
export const isOfTypeDate = (toBeDetermined: unknown): toBeDetermined is Date =>
    isDate(toBeDetermined) && isValid(toBeDetermined);

export const getParsedObjectFromQuery = <T extends Record<string, unknown>>(
    query: ParsedUrlQuery,
    includedKeys: string[]
): Partial<T> => {
    const parsed = {};

    Object.entries(query).map(([key, value]: [string, string | string[]]) => {
        if (includedKeys.includes(key)) {
            // this condition is to avoid compiling errors due to string[]
            if (Array.isArray(value)) {
                parsed[key] = value;
                return;
            } else {
                const parsedDate = parse(
                    value,
                    DATE_FORMAT_BACKEND_STRING,
                    new Date()
                );
                if (isOfTypeDate(parsedDate)) {
                    parsed[key] = parsedDate;

                    return;
                }

                const parsedNumber = parseInt(value);
                if (!isNaN(parsedNumber)) {
                    parsed[key] = parsedNumber;
                } else {
                    parsed[key] = value;
                }
            }
        }
    });

    return parsed as Partial<T>;
};

export const getSerializedObjectForQuery = <T extends Record<string, unknown>>(
    toSerialize: T,
    includedKeys: string[] = Object.keys(toSerialize)
) => {
    const searchSerializable: Partial<Record<string, string>> = {};

    for (const [key, value] of Object.entries(toSerialize)) {
        if (
            value !== undefined &&
            value !== null &&
            value !== '' &&
            includedKeys.includes(key)
        ) {
            if (isOfTypeDate(value)) {
                const dateFormatted = formatStarjackDateToBackendString(value);

                if (dateFormatted) {
                    searchSerializable[key] = dateFormatted;
                }
            } else {
                searchSerializable[key] = value.toString();
            }
        }
    }

    return searchSerializable;
};
